/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const prescriptionTemplateItems = sqliteTable('prescription_template_items', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  template_id: text('template_id'),
  inventory_item_id: text('inventory_item_id'),
  item_name: text('item_name'),
  item_details: text('item_details'),
  item_name_snapshot: text('item_name_snapshot'),
  sku_snapshot: text('sku_snapshot'),
  generic_name_snapshot: text('generic_name_snapshot'),
  brand_name_snapshot: text('brand_name_snapshot'),
  strength_snapshot: text('strength_snapshot'),
  dosage_form_snapshot: text('dosage_form_snapshot'),
  route_snapshot: text('route_snapshot'),
  unit_snapshot: text('unit_snapshot'),
  intake_timing: text('intake_timing'),
  dose_quantity: text('dose_quantity'),
  schedule_morning: integer('schedule_morning'),
  schedule_afternoon: integer('schedule_afternoon'),
  schedule_night: integer('schedule_night'),
  duration_value: integer('duration_value'),
  duration_unit: text('duration_unit'),
  instructions: text('instructions'),
  sort_order: integer('sort_order'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
